import { z } from 'zod';
import { MESSAGE_ROLES, OUTBOUND_SOURCES } from '../types';
import { brandedId, optionalTrimmed, timestampMs, trimmedString } from './_helpers';
export const messageAttachmentSchema = z.object({
    r2Key: trimmedString(512),
    filename: trimmedString(255),
    mimeType: trimmedString(120),
    size: z.number().int().nonnegative(),
});
export const insertMessageSchema = z
    .object({
    id: brandedId().optional(),
    userId: brandedId(),
    conversationId: brandedId(),
    role: z.enum(MESSAGE_ROLES),
    body: z.string().min(1).max(8000),
    systemDetail: optionalTrimmed(500),
    externalMessageId: optionalTrimmed(180),
    outboundSource: z.enum(OUTBOUND_SOURCES).optional(),
    aiDraftId: brandedId().optional(),
    attachments: z.array(messageAttachmentSchema).max(10).default([]),
    sentAt: timestampMs.optional(),
    receivedAt: timestampMs.optional(),
})
    .superRefine((v, ctx) => {
    // sentAt only allowed on outbound; receivedAt only on inbound.
    if (v.role === 'in' && v.sentAt !== undefined) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['sentAt'],
            message: 'inbound messages should not carry sentAt',
        });
    }
    if (v.role === 'out' && v.receivedAt !== undefined) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['receivedAt'],
            message: 'outbound messages should not carry receivedAt',
        });
    }
    if (v.role !== 'out' && v.outboundSource !== undefined) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['outboundSource'],
            message: 'outboundSource only valid on outbound',
        });
    }
});
/** Select shape — drops the superRefine but keeps the same fields + id/createdAt. */
export const selectMessageSchema = z.object({
    id: brandedId(),
    userId: brandedId(),
    conversationId: brandedId(),
    role: z.enum(MESSAGE_ROLES),
    body: z.string(),
    systemDetail: optionalTrimmed(500),
    externalMessageId: optionalTrimmed(180),
    outboundSource: z.enum(OUTBOUND_SOURCES).optional(),
    aiDraftId: brandedId().optional(),
    attachments: z.array(messageAttachmentSchema).default([]),
    sentAt: timestampMs.optional(),
    receivedAt: timestampMs.optional(),
    createdAt: timestampMs,
});
/** Manual message-send form (Review-mode user edits + send).
 *
 * Body cap is 4000 to match the send wire schema
 * (`messageSendCommandSchema` in `extSendCommand.ts`) — a longer body would
 * enqueue fine and then poison at the send consumer (`payload_invalid`).
 */
export const messageDraftFormSchema = z
    .object({
    body: z.string().trim().min(1).max(4000),
    attachments: z.array(messageAttachmentSchema).max(10).default([]),
})
    .strict();
//# sourceMappingURL=message.js.map